import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getAllUsers from '../../services/user/getAllUsers'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchUserComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchUsers () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const userList = yield call(getAllUsers, auth.token)
    yield put(fetchUserComboSuccess(userList))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchUsers () {
  yield takeLatest(combosActionTypes.FETCH_USER_COMBO, fetchUsers)
}
